import { Globe } from "@phosphor-icons/react";
import { useLang } from "@/lib/i18n";

export const LanguageToggle = ({ variant = "light", className = "" }) => {
  const { lang, setLang } = useLang();
  const onLight = variant === "light"; // for solid/light navbar (dark text)

  const base = "px-2 py-0.5 text-sm font-semibold rounded-md transition-colors";
  const activeCls = "bg-forest text-sand";
  const idleCls = onLight
    ? "text-ink/60 hover:text-forest"
    : "text-white/70 hover:text-white";

  return (
    <div
      className={`flex items-center gap-1.5 rounded-full border px-2 py-1 ${
        onLight ? "border-hairline bg-surface/70" : "border-white/30 bg-white/10 backdrop-blur-sm"
      } ${className}`}
      data-testid="language-toggle"
    >
      <Globe size={16} weight="bold" className={onLight ? "text-forest" : "text-gold"} />
      <button
        onClick={() => setLang("en")}
        className={`${base} ${lang === "en" ? activeCls : idleCls}`}
        data-testid="lang-en"
        aria-pressed={lang === "en"}
      >
        EN
      </button>
      <span className={onLight ? "text-hairline" : "text-white/30"}>|</span>
      <button
        onClick={() => setLang("mr")}
        className={`${base} ${lang === "mr" ? activeCls : idleCls}`}
        data-testid="lang-mr"
        aria-pressed={lang === "mr"}
      >
        मराठी
      </button>
    </div>
  );
};

export default LanguageToggle;
